import { CircularProgress, Grid, makeStyles } from "@material-ui/core";
import { Add, Cancel } from "@material-ui/icons";
import * as React from "react";
import { useState } from "react";
import { BooleanInput, Button, Create, NumberInput, TextInput, Toolbar, useNotify } from "react-admin";
import { Form } from "react-final-form";
import { useHistory } from "react-router-dom";
import { SectionTitle } from "../../../../../Components/SectionTitle";
import { Separator } from "../../../../../Components/Separator";
import { useAppDataProvider } from "../../../../../dataprovider";
import { RequestSptPostModel } from "../../../Models/RequestSptModel";

const useStyles = makeStyles({
  toolbar: {
    flex: "auto",
    justifyContent: "flex-end",
    backgroundColor: "white",
  },
  defaultToolbar: {
    flex: "auto",
    justifyContent: "flex-end",
  },
});

export const RequestSptCreate = props => {
  const requestId = props.requestId;
  const [loading, setLoading] = useState(false);
  const dataProvider = useAppDataProvider();
  const notify = useNotify();
  const history = useHistory();
  const classes = useStyles();

  const CreateRequestSptButtonClick = async e => {
    CreateSpt(e);
  };

  const CreateSpt = e => {
    let requestSpt: RequestSptPostModel = new RequestSptPostModel();

    requestSpt.RequestId = requestId;
    requestSpt.Spt = e.spt === undefined ? 0 : e.spt;
    requestSpt.IsExcluded = e.isExcluded;
    requestSpt.Remarks = e.remarks;

    dataProvider.postRequestSpt(requestSpt).then(result => {
      props.finalCallBack();
      notify(`Record created`, "success", false, true);
      setLoading(false);
    });
    history.push("/requestorders/" + requestId + "/6");
  };
  const cancelUpdate = () => {
    props?.finalCallBack?.();
  };

  return (
    <Form
      onSubmit={e => CreateRequestSptButtonClick(e)}
      render={({ handleSubmit, form, values }) => (
        <form>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12}>
              <Create {...props}>
                <>
                  <Grid container xs={12} spacing={1} justify="space-around" alignItems="center">
                    <SectionTitle label="Request SPT" />
                  </Grid>
                  <Separator />
                  <Grid container xs={12} spacing={2} justifyContent="center">
                    <Grid item xs={12} sm={5}>
                      <NumberInput source="spt" label="Request SPT" variant="outlined" fullWidth />
                      <BooleanInput label="IS EXCLUDED" source="isExcluded" defaultValue={false} />
                    </Grid>
                    <Grid item xs={12} sm={5}>
                      <TextInput
                        source="remarks"
                        label="Remarks"
                        multiline
                        resettable
                        fullWidth
                        rows={4}
                        variant="outlined"
                        FormHelperTextProps={{
                          style: { display: "block" },
                        }}
                      />
                    </Grid>
                    <Separator />
                  </Grid>

                  <Toolbar {...props} placeholder="" classes={classes}>
                    <Button
                      label={loading ? "Request SPT is creating!" : "Request SPT"}
                      disabled={loading}
                      size="medium"
                      variant="contained"
                      style={{ margin: "8px", background: "seagreen" }}
                      onClick={() => handleSubmit()}
                    >
                      {loading ? <CircularProgress size="2rem" color="secondary" /> : <Add />}
                    </Button>
                    <Button
                      label={loading ? "Cancel!" : "Cancel "}
                      disabled={loading}
                      size="medium"
                      variant="contained"
                      color="primary"
                      style={{ margin: "8px" }}
                      onClick={cancelUpdate}
                    >
                      {<Cancel />}
                    </Button>
                  </Toolbar>
                </>
              </Create>
            </Grid>
          </Grid>
        </form>
      )}
    />
  );
};
export default RequestSptCreate;
